import { Component, contentChild } from "@angular/core";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";

@Component({
  standalone: false,
  selector: "snoots-page-detail-content",
  template: "<ng-content></ng-content>"
})
export class PageDetailContentComponent {
  template = contentChild(TemplateDirective);
}
